import { render, staticRenderFns } from "./StudentMsg.vue?vue&type=template&id=3712c96c&scoped=true&"
import script from "./StudentMsg.vue?vue&type=script&lang=js&"
export * from "./StudentMsg.vue?vue&type=script&lang=js&"
import style0 from "./StudentMsg.vue?vue&type=style&index=0&id=3712c96c&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3712c96c",
  null
  
)

export default component.exports